import { NgModule } from '@angular/core';
import { PdfWriterLibComponent } from './pdf-writer-lib.component';

@NgModule({
  declarations: [PdfWriterLibComponent],
  imports: [
  ],
  exports: [PdfWriterLibComponent]
})
export class PdfWriterLibModule { }
